<template>
  <div class="com-box" v-if="tmpType == 1">
    <div class="img-box">
      <el-image class="img-demo" :src="img" fit="cover"></el-image>
    </div>
  </div>
  <img class="img" v-else src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/A3/rB8LrWU3rKqALLPTAADTP26dttw763.png" alt="">
</template>

<script>
export default {
  props: {
    tmpType: String
  },
  data() {
    return {
      img: require('@/assets/images/img-demo2.jpg'),
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px
  padding 5px 0
  background linear-gradient(#FFE8DF, #FFE8DF)
  border-radius: 12px
  .img-box
    margin 12px
    background-color: #FFF0EA
    border-radius: 12px
    overflow hidden
    font-size 0
.img {
  width: 100%;
  height: 100%;
}
</style>